import i18n from '../i18n'
export default {
  install: function (Vue) {
    const GENDER = [
      {
        id: 1,
        name: 'label.gender.male',
        suffix: 'label.gender-suffix.male'
      },
      {
        id: 2,
        name: 'label.gender.female',
        suffix: 'label.gender-suffix.female'
      }
    ]
    Vue.prototype.$gender = {
      getSuffix (id) {
        let result = '';
        GENDER.forEach((val) => {
          if (id === val.id) {
            result = i18n.t(val.suffix)
            return
          }
        })
        return result
      },
      getOptions () {
        const result = []
        GENDER.forEach((val) => {
          result.push({ id: val.id, label: i18n.t(val.name) })
        })
        return result
      }
    }
  }
}